module.exports = __webpack_public_path__ + "io.64784138b540da57c244.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/io.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/io.svg
// module chunks = styles